import { render, staticRenderFns } from "./MessageEditorText.vue?vue&type=template&id=b0d24e1e&scoped=true&"
import script from "./MessageEditorText.vue?vue&type=script&lang=js&"
export * from "./MessageEditorText.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorText.vue?vue&type=style&index=0&id=b0d24e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d24e1e",
  null
  
)

export default component.exports